<template>
  <validation-observer
    ref="form"
    #default="{ invalid }"
    tag="form"
    class="repeater__form"
    style="overflow: visible"
  >
    <b-modal
      v-model="show"
      content-class="package-modal rounded-8"
      dialog-class="wameed-modal-md"
      no-fade
    >
      <template slot="modal-header-close">
        <close-icon />
      </template>

      <template slot="modal-title">
        <div class="d-block text-center">
          <h3 class="text-reg-18">
            {{ $t('orders.new.client') }}
          </h3>
        </div>
      </template>

      <b-row>
        <b-col md="12">

          <!-- Search -->
          <text-input
            v-model="search"
            icon="search-icon"
            is-append
            input-classes="text-reg-14"
            name="search"
            :placeholder="$t('common.search') + ' ...'"
            field-classes="mb-0 notification-filter-search"
          />

          <!-- Users List -->
          <div class="w-table my-4 notification-filter-list">
            <label
              class="custom-input input-bottom-border notification-filter-option"
              v-for="(user, index) in users"
              :key="index"
              :class="[selectedUser && selectedUser.id === user.id ? 'active' : '']"
              @click="selectUser(user)"
            >
              <name-tile
                :name="user.name"
                :phone="user.phone"
                :image="user.image"
              />
            </label>

            <div v-if="loading" class="text-center py-3">
              {{ $t('common.loading') }}...
            </div>
          </div>

        </b-col>
      </b-row>

      <template slot="modal-footer">
        <wameed-btn
          classes="text-med-14 text-white mx-0 rounded-8"
          :title="modalData ? $t('btn.update') : $t('btn.ok')"
          :disabled="invalid"
          type="submit"
          variant="main"
          @onClick="submitOrder()"
        />
        <wameed-btn
          classes="text-med-14 text-font-secondary mx-0 rounded-8"
          :title="$t('btn.cancel')"
          type="button"
          variant="gray"
          @onClick="closeModal()"
        />
      </template>

    </b-modal>
  </validation-observer>
</template>


<script>
import { ValidationObserver } from 'vee-validate';
import { WameedBtn, WameedTextInput as TextInput } from 'wameed-ui/dist/wameed-ui.esm';
import NameTile from '@/components/nameTile.table.vue';
import { mapGetters } from "vuex";

export default {
  components: {
    NameTile,
    ValidationObserver,
    WameedBtn,
    TextInput
  },

  props: {
    visible: { type: Boolean, default: false },
    modalData: { type: Object, default: null }
  },

  data() {
    return {
      search: "",
      selectedUser: null
    };
  },

  computed: {
    ...mapGetters({
      users: "admin/newOrder/getUsers",
      loading: "admin/newOrder/getLoading"
    }),

    show: {
      get() { return this.visible; },
      set(value) {
        if (!value) this.$emit("close");
      }
    }
  },

  watch: {
    search() {
      this.fetchUsers();
    }
  },

  mounted() {
    this.fetchUsers();
  },

  methods: {
    fetchUsers(page = 1) {
      this.$store.dispatch("admin/newOrder/getUsers", {
        page,
        search: this.search
      });
    },

    selectUser(user) {
      this.selectedUser = user;
    },

    submitOrder() {
      if (!this.selectedUser) {
        alert("قم باختيار مستخدم");
        return;
      }
      this.$emit("onComplete", this.selectedUser);
      this.closeModal();
    },

    closeModal() {
      this.search = "";
      this.selectedUser = null;
      this.show = false;
    }
  }
};
</script>
